import { useMemo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { localizedLabels, MediaDropLabelsProvider } from '@arthelper/ui';

/**
 * Localized MediaDrop copy for every drop in the app. A call site's own `labels`
 * still win, so surfaces with their own wording (DMs, Arty, artwork) keep it.
 */
export function MediaDropLabels({ children }: { children: ReactNode }) {
  const { t } = useTranslation('common');
  const labels = useMemo(() => localizedLabels((key, values) => t(key, values)), [t]);
  return <MediaDropLabelsProvider value={labels}>{children}</MediaDropLabelsProvider>;
}
